import {  Directive,  HostListener,  EventEmitter,  ElementRef,  Input,  OnChanges,  SimpleChanges,  OnDestroy, NgModule} from "@angular/core";
import { NgControl } from "@angular/forms";
import { fromEvent, Subscription } from "rxjs";
import { sanitize } from "../../ph-bhp-ui.service";

@Directive({
  selector: '[inputSanitizer]'
})
export class PhBhpInputSanitizerDirective implements OnDestroy {

  actualValue: string = "";
  transformedValue = "";
  control: NgControl;
  constructor(private element: ElementRef, private elementControl : NgControl) {
    this.control = elementControl;
    fromEvent(element.nativeElement, "input").subscribe((target:any) => {
      this.transformValue(target.value);
    });
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string): void {
    this.trimInput(value);
  }

  transformValue(value: any) {
    this.element.nativeElement.value = sanitize(this.element.nativeElement.value);
    this.control ? this.control.reset(this.element.nativeElement.value) : '';
  }

  trimInput(value: string): void {
    let trimmedValue = value.trim();
    this.control.valueAccessor.writeValue(trimmedValue);
    this.control.control.setValue(trimmedValue);
  }

  ngOnDestroy() {
  }
}
